import _findIndex from 'lodash/findIndex';
import * as ActionTypes from '../../actions/types/website/EntityActionTypes';
import * as FileActionTypes from '../../actions/types/website/FileUploadActionTypes';

const initialState = {
  busy: false,
  byId: {},
  orderedIds: [],
  selectedEntityId: undefined,
  filePreview: {},
  address: {},
  mealOptions: [],
  referenceKey: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ENTITY_ADD: {
      return Object.assign({}, state, { address: {}, selectedEntityId: undefined, filePreview: {} });
    }
    case ActionTypes.ENTITY_REQUESTED: {
      return Object.assign({}, state, { busy: true }, { address: {} });
    }
    case ActionTypes.ENTITY_RECEIVED: {
      const byId = { ...state.byId };
      byId[action.payload.entity.id] = action.payload.entity;
      return Object.assign({},
        state,
        { byId },
        { busy: false },
        { selectedEntityId: undefined });
    }
    case ActionTypes.ENTITY_CREATED: {
      const byId = { ...state.byId };
      byId[action.payload.entity.id] = action.payload.entity;
      const orderedIds = [...state.orderedIds];
      orderedIds.push(action.payload.entity.id);
      return Object.assign({},
        state,
        { byId, orderedIds },
        { busy: false },
        { address: {} },
        { selectedEntityId: undefined });
    }
    case ActionTypes.ENTITIES_REQUESTED: {
      return Object.assign({}, state, { busy: true }, { address: {} });
    }
    case ActionTypes.ENTITIES_RECEIVED: {
      const byId = {};
      action.payload.entities.forEach(entity => (byId[entity.id] = entity));
      const orderedIds = action.payload.entities.map(entity => entity.id);
      return Object.assign({},
        state,
        { byId, orderedIds }, // eslint-disable-line
        { busy: false },
        { filePreview: {} });
    }

    case ActionTypes.ENTITY_MOVE: {
      const orderedIds = Object.assign([], state.orderedIds);
      orderedIds.splice(action.payload.newIndex, 0, orderedIds.splice(action.payload.oldIndex, 1)[0]);
      return Object.assign({}, state, { orderedIds });
    }
    case ActionTypes.ENTITY_MOVED: {
      const orderedIds = action.payload.entities.map(entity => entity.entity_id);
      return Object.assign({}, state, { orderedIds });
    }
    case ActionTypes.ENTITY_SELECTED: {
      return Object.assign({}, state, { selectedEntityId: action.payload.id }, { address: {}, filePreview: {} });
    }
    case ActionTypes.ENTITY_DELETED: {
      const byId = { ...state.byId };
      delete byId[action.payload.id];

      const orderedIds = [...state.orderedIds];
      const index = _findIndex(orderedIds, i => i === action.payload.id);
      orderedIds.splice(index, 1);

      let selectedEntityId = state.selectedEntityId;
      if (state.selectedEntityId && state.selectedEntityId === action.payload.id) {
        selectedEntityId = undefined;
      }

      return Object.assign({},
        state,
        { byId, orderedIds, selectedEntityId },
        { busy: false },
        { selectedEntityId });
    }
    case ActionTypes.ENTITIES_RESET: {
      return Object.assign({}, initialState);
    }
    case ActionTypes.REQUEST_ADDRESS: {
      const address = { busy: true };
      return Object.assign({}, state, { address });
    }
    case ActionTypes.RECEIVE_ADDRESS: {
      const result = action.payload;
      const address = result;
      if (action.overrideName) {
        address[action.overrideName] = result.name;
        delete address.name;
      }
      if (!address.url) {
        address.url = address.google_url;
      }
      address.google_map_url = address.google_url;
      address.busy = false;
      return Object.assign({}, state, { address });
    }
    case ActionTypes.RESET_ADDRESS: {
      return { ...state, address: {} };
    }
    case ActionTypes.SUGGESTIONS_RECEIVED: {
      const suggestions = action.payload;
      return Object.assign({},
        state,
        { suggestions });
    }
    case FileActionTypes.FILE_UPLOADING: {
      const newFilePreview = {};
      newFilePreview[action.payload] = { busy: true };
      const filePreview = Object.assign(state.filePreview, newFilePreview);
      return Object.assign({},
        state,
        { filePreview });
    }
    case FileActionTypes.FILE_UPLOADED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({},
        state,
        { filePreview });
    }
    case FileActionTypes.STORE_REFERENCE_KEY: {
      return {
        referenceKey: action.payload
      };
    }
    case FileActionTypes.FILE_TEMP_UPLOADED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({},
        state,
        { filePreview });
    }
    case FileActionTypes.FILE_CROPPED: {
      const filePreview = Object.assign(state.filePreview, action.payload);
      return Object.assign({},
        state,
        { filePreview });
    }
    // case ActionTypes.MEAL_OPTIONS_REQUESTED: {
    //   const mealOptions = { busy: true };
    //   return Object.assign({},
    //     state,
    //     { mealOptions }
    //   );
    // }
    case ActionTypes.MEAL_OPTIONS_RECEIVED: {
      const mealOptions = action.payload;
      return Object.assign({},
        state,
        { mealOptions });
    }
    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/website/entities.js